import type {
  Document,
  ParentFolders,
} from '@features/documents/api/types/document.types';

export function buildParentFoldersForNavigation(
  document: Document,
  currentParentFolders: ParentFolders[]
): ParentFolders[] {
  return [...currentParentFolders, { id: document.id, name: document.name }];
}
